import { createContext } from "react";

export type WeekViewMode = "stacked" | "hours";

export type WeekViewContextProps = {
	mode: WeekViewMode;
};

export const WeekViewContext = createContext<WeekViewContextProps>({
	mode: "stacked"
});